import { useTranslate } from '@ur-solutions/react-hooks'
import { Card } from '@/components_deprecated/Card'
import { PopupMenu } from '@/components_deprecated/PopupMenu'
import { SelectWeekDays } from '@/components_deprecated/SelectWeekday/SelectWeekDays'
import styled from 'styled-components'
import type { PeriodAddonForm } from './PeriodAddonPrompt'
import { format } from 'date-fns'

const OvertimePeriodViewWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
`

const Wrapper = styled(Card)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin: 1rem 0;
`

const TextWrapper = styled.div`
  padding: 1rem;
  font-size: 16px;
  background-color: ${props => props.theme.colors.gray11};
  color: ${props => props.theme.colors.primary};
  border-radius: 1rem;
  font-weight: 600;
  ${props => props.theme.media.mobile} {
    font-size: 12px;
  }
`

interface PeriodAddonViewProps {
  periodAddon: PeriodAddonForm
  onEdit: () => void
  onDelete: () => void
}

export const PeriodAddonView: React.FC<PeriodAddonViewProps> = ({
  periodAddon,
  onEdit,
  onDelete,
}) => {
  const translations = useTranslate({
    edit: 'common.edit',
    delete: 'common.delete-alt',
    wholeDay: 'common.whole-day',
  })

  const intervalDisplayString =
    format(periodAddon.start, 'HH:mm') +
    ' - ' +
    format(periodAddon.end, 'HH:mm')
  const wholeDay =
    periodAddon.start.getHours() === 0 &&
    periodAddon.end.getMinutes() === 0 &&
    periodAddon.end.getHours() === 0 &&
    periodAddon.end.getMinutes() === 0
  return (
    <Wrapper key={periodAddon.id}>
      <OvertimePeriodViewWrapper>
        <SelectWeekDays
          initialValues={[
            periodAddon.monday,
            periodAddon.tuesday,
            periodAddon.wednesday,
            periodAddon.thursday,
            periodAddon.friday,
            periodAddon.saturday,
            periodAddon.sunday,
          ]}
          disabled
        />

        <TextWrapper>
          {wholeDay ? translations.wholeDay : intervalDisplayString}
        </TextWrapper>

        <TextWrapper>
          {periodAddon.salaryCodeName ? periodAddon.salaryCodeName : ''}
        </TextWrapper>
      </OvertimePeriodViewWrapper>
      <PopupMenu
        items={[
          { label: translations.edit, onClick: onEdit },
          { label: translations.delete, onClick: onDelete },
        ]}
      />
    </Wrapper>
  )
}
